// MOCK VERİ - Backend entegrasyonu yapıldığında bu veriler API'den gelecektir.
// Şu an orijinal uygulamadaki gibi localStorage tabanlı çalışmaktadır.

export const initialRecords = [
  {
    id: 1,
    fullName: "Kerem Demir",
    plateNo: "34 KRM 45",
    carModel: "Volkswagen Passat Beyaz",
    relationDegree: "Ev Sahibi",
    aptNo: "B Blok D:5",
    phoneNo: "0532 555 1234",
    infoNote: "Aidatını düzenli ödüyor.",
  },
  {
    id: 2,
    fullName: "Zeynep Kaya",
    plateNo: "34 ZYN 07",
    carModel: "Audi A3 Gri",
    relationDegree: "Kiracı",
    aptNo: "A Blok D:2",
    phoneNo: "0533 444 9876",
    infoNote: "",
  },
];

export const appThemes = {
  green: { 50: "240 253 244", 500: "34 197 94", 600: "22 163 74", 700: "21 128 61" },
  blue: { 50: "239 246 255", 500: "59 130 246", 600: "37 99 235", 700: "29 78 216" },
  purple: { 50: "250 245 255", 500: "168 85 247", 600: "147 51 234", 700: "126 34 206" },
  rose: { 50: "255 241 242", 500: "244 63 94", 600: "225 29 72", 700: "190 18 60" },
  amber: { 50: "255 251 235", 500: "245 158 11", 600: "217 119 6", 700: "180 83 9" },
};
